module.exports = __webpack_public_path__ + "static/media/eagm-steps-vertical.4d26ecde.png";